import AuthContainer from '@/components/auth/AuthContainer';
import ForgotPasswordForm from '@/components/auth/ForgotPasswordForm';
import TermsAndConditions from '@/components/auth/legal-links/TermsAndConditions';
import { useAuthProvider } from '@/hooks/auth/useAuthProvider';

export default function ForgotPassword() {
	const { handleForgotPassword, loadingState } = useAuthProvider();

	return (
		<AuthContainer>
			<div className="flex flex-col items-center justify-center h-full w-full p-8 mt-8">
				<div className="bg-white rounded-2xl glassy-shadow-inset-outward p-8 w-full min-h-[50vh] flex items-center justify-center">
					<div
						className="w-full flex flex-col items-center justify-center"
						data-testid="forgot-password-page"
					>
						<p className="text-2xl text-center mb-6 mt-2 font-bold">
							Forgot Password
						</p>

						<div className="w-full max-w-sm">
							<ForgotPasswordForm
								handleSubmit={handleForgotPassword}
								loading={loadingState.forgotPassword}
							/>
						</div>
					</div>
				</div>
				<div className="w-full max-w-sm text-center mt-4">
					<TermsAndConditions />
				</div>
			</div>
		</AuthContainer>
	);
}
